import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Heart, AlertTriangle, Flame } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Contact Info */}
          <div className="bg-gray-800 border border-gray-700 rounded-3xl shadow-md card-hover p-6">
            <h3 className="text-xl font-semibold mb-4 text-primary">PGD Zgornja Polskava</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={20} className="text-primary mt-1" />
                <div>
                  <p className="text-gray-300">Gasilski dom Zgornja Polskava</p>
                  <p className="text-gray-300">Mladinska ulica 12</p>
                  <p className="text-gray-300">2314 Zgornja Polskava</p>
                  <p className="text-gray-300">Slovenija</p>
                  <a 
                    href="https://maps.google.com/?q=Mladinska+ulica+12,+2314+Zgornja+Polskava,+Slovenia" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-xs text-primary hover:text-white transition-colors mt-1 inline-block"
                  >
                    Odpri v Google Maps
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <Phone size={20} className="text-primary" />
                <a href="tel:+38627525020" className="footer-link">+386 2 752 50 20</a>
              </div>
              
              <div className="flex items-center gap-3">
                <Mail size={20} className="text-primary" />
                <a href="mailto:info@pgd-zgornja-polskava.si" className="footer-link">info@pgd-zgornja-polskava.si</a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="bg-gray-800 border border-gray-700 rounded-3xl shadow-md card-hover p-6">
            <h3 className="text-xl font-semibold mb-4 text-primary">Povezave</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="footer-link">Domov</Link></li>
              <li><Link to="/o-nas" className="footer-link">O nas</Link></li>
              <li><Link to="/kontakt" className="footer-link">Kontakt</Link></li>
              <li><Link to="/oprema" className="footer-link">Oprema</Link></li>
              <li><Link to="/intervencije" className="footer-link">Intervencije/Novice</Link></li>
              <li><Link to="/donacija" className="footer-link">Donacija dohodnine</Link></li>
            </ul>
          </div>

          {/* Emergency Info */}
          <div className="bg-gray-800 border border-gray-700 rounded-3xl shadow-md card-hover p-6">
            <h3 className="text-xl font-semibold mb-4 text-primary">V nujnem primeru</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <AlertTriangle size={24} className="text-primary" />
                <a href="tel:112" className="text-2xl font-bold text-white hover:text-primary transition-colors">112</a>
              </div>
              <p className="text-gray-300 text-sm">
                Za vse nujne primere pokličite številko <strong>112</strong>, in operater vas bo povezal z ustrezno intervencijsko službo.
              </p>
              <div className="flex items-center mt-2 pt-2 border-t border-gray-700">
                <Flame className="text-primary mr-2" size={20} />
                <p className="text-gray-300 text-sm">
                  Požar? Nesreča? Poplava? <br /> 
                  <span className="text-white font-semibold">Kličite 112!</span>
                </p>
              </div>
            </div>
          </div>

          {/* Social Media */}
          <div className="bg-gray-800 border border-gray-700 rounded-3xl shadow-md card-hover p-6">
            <h3 className="text-xl font-semibold mb-4 text-primary">Spremljajte nas</h3>
            <div className="flex space-x-4 mb-6">
              <a 
                href="#" 
                className="bg-gray-700 hover:bg-primary rounded-full transition-colors p-3"
                aria-label="Facebook"
              >
                <Facebook size={20} className="text-white" />
              </a>
              <a 
                href="#" 
                className="bg-gray-700 hover:bg-primary rounded-full transition-colors p-3"
                aria-label="Instagram"
              >
                <Instagram size={20} className="text-white" />
              </a>
            </div>
            <p className="text-gray-300 text-sm">
              Spremljajte nas na družbenih omrežjih za najnovejše novice, dogodke in aktivnosti našega društva.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-400 text-sm">
          <p>© {new Date().getFullYear()} PGD Zgornja Polskava. Vse pravice pridržane.</p>
          <p className="mt-2 flex items-center justify-center gap-1">
            Made with <Heart size={16} className="text-primary animate-pulse" /> by <a href="https://digitalpro.dev/" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-white transition-colors">DigitalPro</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;